// extracted by mini-css-extract-plugin
export default {"container":"Selection_container__JbufH","selection":"Selection_selection__DXbjL","select":"Selection_select__uzMyJ","input":"Selection_input__YJlDl"};